/**
 * 正则规则校验
 */

export const regex = {
  //1-120岁
  age: {
    rules: /^(?:[1-9][0-9]?|1[01][0-9]|120)$/, 
    label: '请输入不为0且不超过120的正整数'
  },
   //正整数或一位小数或者俩位小数  //评卷量
  twoDecimalPoint: {
    rules: /^[0-9]+([.]{1}[0-9]{1,2})?$/,
    label: '不能为负数且最多2位小数点'
  },
  //是否为11位有效手机号码
  phone: {
    rules: /^[1][3,4,5,7,8][0-9]{9}$/,
    label: '请输入有效的手机号码'
  }, 
  //邮箱
  email: {
    rules: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
    label: '请输入正确的邮箱'
  }, 
  //这个项目不限制 //姓名
  name: { 
    rules: /^[\u4E00-\u9FA5]{2,4}$/,
    label: '请输入中文姓名'
  },
  //身份证号
  card: {
    rules: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
    label: '请输入有效的身份证号'
  }, 
  float: /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/, //负浮点数
  notFloat: /^\d+(\.\d+)?$/, //非负浮点数
  integer: /^[0-9]+$/, //正整数
  integerNotZero: /^[1-9]\d*$/, //大于0的正整数
  //密码
  password: {
    rules: /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,16}$/,
    label: '密码必须在8-16位区间，同时包含数字，字母，其他字符中的两种或以上'
  },
  //无效率
  maxHundredTwoPoint: {
    rules: /(?!^0\.0?0$)^[0-9][0-9]?(\.[0-9]{1,2})?$|^100$/,
    label: '请输入0-100的数字且最多2位小数点'
  },
  //开户行信息
  openingBank: {
    rules: /^.{1,50}$/,
    label: '50位以内开户行信息'
  },
  //银行卡号
  bankCard: {
    rules: /(^\d{15}$)|(^\d{17}([0-9])$)/,
    label: '15或18位以内开户账号'
  },
  //简介
  introduction: {
    rules: /^[\s\S]{1,1024}$/,
    label: '1024位以内简介'
  },
  //地址
  address: {
    rules: /^.{1,128}$/,
    label: '128位以内地址'
  }

}